'use client';

import {HeroMediaSectionFieldsFragment} from '@generated/graphql';
import Video from '@/components/ui/video/Video';
import {StyledHeroMediaContainer, StyledHeroImage} from '@/components/sections/hero-media-section/HeroMediaSection.styles';
import ScrollDownButton from '@/components/ui/scroll/ScrollDownButton';
import HeroMediaOverlay from '@/components/sections/hero-media-section/HeroMediaOverlay';
import HeroMediaSectionV2 from '@/components/sections/hero-media-section/HeroMediaSectionV2';
import {useMediaQuery, useTheme} from '@mui/material';

const HeroMediaSectionLegacy = (fields: HeroMediaSectionFieldsFragment) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('heroVideoBreakpoint'));
  const isExtraSmallScreen = useMediaQuery('(max-width: 374px)');

  const smallScreenUrl = fields.smallScreenMedia?.url;
  const smallScreenContentType = fields.smallScreenMedia?.contentType;

  const mediaUrl = (isSmallScreen && smallScreenUrl) ? smallScreenUrl : (fields.media?.url ?? '');
  const isVideo = Boolean(
    (isSmallScreen && smallScreenUrl)
      ? smallScreenContentType?.startsWith('video/')
      : fields.media?.contentType?.startsWith('video/')
  );

  const heading = fields.heading;
  const activeLinks = fields.linksCollection?.items ?? [];

  return (
    <StyledHeroMediaContainer data-hero-media {...fields.id && { id: fields.id }}>
      {isVideo ? (
        <Video key={mediaUrl} posterImage={fields.posterImage?.url ?? ''} src={mediaUrl} controls={false} height={isExtraSmallScreen ? '95vh' : undefined} />
      ) : (
        <StyledHeroImage src={mediaUrl} alt={fields.altText ?? ''} />
      )}
      <HeroMediaOverlay heading={heading} subText={fields.subText} links={activeLinks} />
      <ScrollDownButton />
    </StyledHeroMediaContainer>
  );
};

const HeroMediaSection = (fields: HeroMediaSectionFieldsFragment) =>
  fields.version === 'v2'
    ? <HeroMediaSectionV2 {...fields} />
    : <HeroMediaSectionLegacy {...fields} />;

export default HeroMediaSection;
